"use client"

import clsx from "clsx"

import type { PropsWithClassName } from "~/@types/generics"
import { useGridLayoutContext } from "~/providers/GridLayoutProvider/index.client"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"

import { hideFrom, showFrom } from "~/styles/utils/show-hide"

import * as css from "./styles.css"

export function AlgoliaGridLayoutSwitcher({ className }: PropsWithClassName) {
  const { layout, setLayout } = useGridLayoutContext()
  const t = useTranslate()

  const handleOnClick = () => {
    setLayout((prevLayout) => (prevLayout === "mobile-1-desktop-3" ? "mobile-2-desktop-6" : "mobile-1-desktop-3"))
  }

  return (
    <button
      className={clsx(className, css.AlgoliaGridLayoutSwitcher)}
      aria-label={t("filter_view")}
      onClick={handleOnClick}
    >
      {t("filter_view")}{" "}
      <div className={showFrom("tablet", "block")}>
        {layout === "mobile-1-desktop-3" ? (
          <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.967041" width="14" height="14" stroke="currentColor" />
            <path d="M11 0.896729V15.1819M4 0.896729L4 14.8967M7.50428 0.896729V15.1819" stroke="currentColor" />
          </svg>
        ) : (
          <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.967041" width="14" height="14" stroke="currentColor" />
            <path d="M10.0098 0.467041V15.467M5.00977 1.18188L5.00977 15.1819" stroke="currentColor" />
          </svg>
        )}
      </div>
      <div className={hideFrom("tablet", "block")}>
        {layout === "mobile-1-desktop-3" ? (
          <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.967041" width="14" height="14" stroke="currentColor" />
            <line x1="7.50391" y1="0.467041" x2="7.50391" y2="15.467" stroke="currentColor" />
          </svg>
        ) : (
          <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.967041" width="14" height="14" stroke="currentColor" />
          </svg>
        )}
      </div>
    </button>
  )
}
